// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
.loginIntro_container__x6x2q {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex-direction: column;
}

.loginIntro_body__AOkdW {
  background: #000;
  height: 100vh;
}

.loginIntro_wrapper__EJznc {
  display: flex;
  text-align: left;
  align-items: flex-start;
  flex-direction: column;
}
.loginIntro_wrapper__EJznc h3 {
  font-family: GteDisplayBold;
  font-weight: 700;
  font-size: 28px;
  color: #ffffff;
  line-height: 32px;
  margin-top: 100%;
}
.loginIntro_wrapper__EJznc h3 span {
  color: #C7FF24;
}
.loginIntro_wrapper__EJznc p {
  font-family: GteDisplayLight;
  color: #C2C2C2;
  font-size: 14px;
  line-height: 16px;
  margin-top: 6px;
}
.loginIntro_wrapper__EJznc button {
  font-family: GteDisplayLight;
  background: #C7FF24;
  font-weight: 500;
  font-size: 16px;
  width: 100%;
  padding: 14px;
  text-align: center;
  border-radius: 30px;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/loginIntro/loginIntro.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AAAF;AACE;EACE,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AAAI;EACE,cAAA;AAEN;AAEE;EACE,4BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAAJ;AAGE;EACE,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AADJ","sourcesContent":["@font-face {\r\n  font-family: \"GteDisplayBold\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayLight\";\r\n  src: url('../../shared/font/gteestiprodisplay_light.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n.container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  flex-direction: column;\r\n  }\r\n\r\n.body {\r\n  background: #000;\r\n  height: 100vh;\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  text-align: left;\r\n  align-items: flex-start;\r\n  flex-direction: column;\r\n  h3 {\r\n    font-family: GteDisplayBold;\r\n    font-weight: 700;\r\n    font-size: 28px;\r\n    color: #ffffff;\r\n    line-height: 32px;\r\n    margin-top: 100%;\r\n    span {\r\n      color: #C7FF24;\r\n    }\r\n  }\r\n\r\n  p {\r\n    font-family: GteDisplayLight;\r\n    color: #C2C2C2;\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    margin-top: 6px;\r\n  }\r\n\r\n  button {\r\n    font-family: GteDisplayLight;\r\n    background: #C7FF24;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    width: 100%;\r\n    padding: 14px;\r\n    text-align: center;\r\n    border-radius: 30px;\r\n    margin-top: 20px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `loginIntro_container__x6x2q`,
	"body": `loginIntro_body__AOkdW`,
	"wrapper": `loginIntro_wrapper__EJznc`
};
export default ___CSS_LOADER_EXPORT___;
